import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SliceCallState } from "../slices/sliceCallState";
import { User } from "../models/User";

export interface UserState {
  user: User;
  loading: SliceCallState;
}

const initialState: UserState = {
  user: {
    userId: 0,
    username: "",
    fullName: "",
    complexityId: 0,
    status: "",
    type: "",
  },
  loading: SliceCallState.idle,
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setUserData: (state: UserState, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.loading = SliceCallState.succeeded;
    },
    setLoadingData: (state: UserState, action: PayloadAction<SliceCallState>) => {
      state.loading = action.payload;
    },
  },
});

export const actions = userSlice.actions;
